import React, { PureComponent, Fragment } from 'react';
import LazyLoad from 'react-lazyload';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Picture } from 'formlabs-web-components/Media';
import classNames from 'classnames';
import VideoCover from 'react-video-cover';
import TextPlugin from '../cms/TextPlugin';

import withDeviceType from '../../hoc/withDeviceType';

import './Video.module.css';

const VideoSection = DisplayComponent(
  class VideoSection extends PureComponent {
    render() {
      const {
        body,
        video,
        videoThumb,
        copySize,
        videoSize,
        copyAlignment,
        children,
        darkOverlay,
        hasContainer,
        backgroundVideo,
        overlapMenu,
        heightRestrict,
        copyColor,
        classes,
        phoneSizedImage,
        isMobile,
        isTablet,
        mobileVerticalCopyAlignment
      } = this.props;
      const copyAlign = copyAlignment === 'right' ? 2 : 0;
      const videoResize = videoSize + copySize > 24 ? copySize : videoSize;
      const videoHtml = (
        <div className="width-correction font-correction" styleName="media">
          {darkOverlay && <div styleName="dark-video-overlay" />}
          {!isTablet && !isMobile ? (
            <VideoCover
              videoOptions={{
                src: video,
                autoPlay: true,
                loop: true,
                muted: true,
                playsInline: true
              }}
            />
          ) : null}
          {isTablet && (
            <Picture
              largeImage={videoThumb || phoneSizedImage}
              fullBleed={true}
            />
          )}
          {isMobile && (
            <Picture
              largeImage={phoneSizedImage || videoThumb}
              fullBleed={true}
            />
          )}
        </div>
      );
      if (backgroundVideo) {
        return (
          <div
            className={`${hasContainer ? 'has-full-container' : ''} ${classes}`}
            styleName={classNames('video-section-container', {
              overlap: overlapMenu,
              'height-restricted': heightRestrict,
              'white-text': copyColor === 'white'
            })}
          >
            {(videoThumb || phoneSizedImage) && (
              <LazyLoad
                offsetTop={200}
                placeholder={
                  <Picture
                    largeImage={videoThumb || phoneSizedImage}
                    fullBleed={true}
                  />
                }
                once
              >
                {videoHtml}
              </LazyLoad>
            )}
            {!videoThumb && !phoneSizedImage && (
              <Fragment>{videoHtml}</Fragment>
            )}
            {body && (
              <div
                styleName={`background-positioner mobile-${mobileVerticalCopyAlignment ||
                  'center'}`}
              >
                <div styleName="fix-width">
                  <Grid
                    direction="x"
                    gutters="margin"
                    hasContainer={true}
                    primaryAlignment={`align-${copyAlignment}`}
                  >
                    <Cell smallSize={24} largeSize={copySize}>
                      <div className={`${darkOverlay ? 'dark' : ''}`}>
                        <TextPlugin body={body}>{children}</TextPlugin>
                      </div>
                    </Cell>
                  </Grid>
                </div>
              </div>
            )}
          </div>
        );
      } else {
        return (
          <div
            className={`${hasContainer ? 'has-full-container' : ''} ${classes}`}
            styleName="video-section-container"
          >
            <Grid
              direction="x"
              gutters="margin"
              hasContainer={true}
              primaryAlignment="align-spaced"
            >
              <Cell
                largeSize={videoResize}
                styles={{ order: 1 }}
                mediumSize={videoResize}
              >
                {!isTablet && !isMobile ? (
                  <VideoCover
                    videoOptions={{
                      src: video,
                      autoPlay: true,
                      loop: true,
                      muted: true,
                      playsInline: true
                    }}
                  />
                ) : null}
                {isTablet && (
                  <Picture
                    largeImage={videoThumb || phoneSizedImage}
                    fullBleed={true}
                  />
                )}
                {isMobile && (
                  <Picture
                    largeImage={phoneSizedImage || videoThumb}
                    fullBleed={true}
                  />
                )}
              </Cell>
              <Cell
                largeSize={copySize}
                mediumSize={copySize}
                secondaryAlignment="align-self-middle"
                styles={{
                  order: copyAlign
                }}
              >
                <div className={`${darkOverlay && !isTablet ? 'dark' : ''}`}>
                  <TextPlugin body={body}>{children}</TextPlugin>
                </div>
              </Cell>
            </Grid>
          </div>
        );
      }
    }
  }
);

VideoSection.propTypes = {};

export default withDeviceType(VideoSection);
